import { hour, minute, parse, second } from 'app/lib/date'

// round viewing time to next 15 minute increment e.g. 9:15 -> 9:30, 9:55 -> 10:00
// accepts a time string
// returns Moment object
export const roundViewingTime = (timeString) => {
  let time = parse(timeString)

  // NOTE: There are algorithmic ways to do this but for clarity and to make
  // changes easier in the future, elected for conditional approach.
  if (minute(time) === 0) {
    return time
  }

  if (minute(time) <= 15) {
    time = minute(time, 15)
    return second(time, 0)
  }

  if (minute(time) <= 30) {
    time = minute(time, 30)
    return second(time, 0)
  }

  if (minute(time) <= 45) {
    time = minute(time, 45)
    return second(time, 0)
  }

  if (minute(time) > 45) {
    time = hour(time, hour(time) + 1)
    time = minute(time, 0)
    return second(time, 0)
  }

  // if no condition met
  return time
}
